export default function FeaturesSection() {
  const features = [
    {
      title: '30 Days Planned',
      description: 'A full month of content strategy mapped out for you. Know exactly what to post, in what format, and at what time — every single day.',
      icon: 'ri-calendar-line'
    },
    {
      title: '30 Done-For-You Captions',
      description: 'Every caption is written and ready. Replace the [brackets] with your details and post. Zero blank page. Zero guesswork.',
      icon: 'ri-edit-line'
    },
    {
      title: '30 Reel Hook Scripts',
      description: 'The hardest part of reels is the first 3 seconds. Every hook is written to stop the scroll and drive profile visits.',
      icon: 'ri-movie-line'
    },
    {
      title: 'Fully Editable in Canva',
      description: 'Every template opens directly in Canva. Swap your logo, colors, and text in minutes — no design skills required.',
      icon: 'ri-palette-line'
    },
    {
      title: '15 Story Prompts',
      description: 'Engagement-driving story ideas with sticker recommendations — polls, quizzes, countdowns, and CTAs that fill your DMs.',
      icon: 'ri-smartphone-line'
    },
    {
      title: 'Profile & Bio Checklist',
      description: '10-point audit to optimize your Instagram page today. Your profile is your storefront — make it close deals before you even DM back.',
      icon: 'ri-user-star-line'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-4">
          <div className="text-sm font-semibold text-[#E8603C] uppercase tracking-wider mb-3">
            What's Included
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Everything In The Box
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A full month of content strategy mapped out for you. Never wonder what to post again.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#F8F4EF] p-8 rounded-2xl border border-black/6 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10),0_30px_60px_rgba(0,0,0,0.14)] transition-all duration-200 hover:-translate-y-1"
              style={{
                boxShadow: '0 6px 12px rgba(0,0,0,0.06), 0 18px 40px rgba(0,0,0,0.10)'
              }}
            >
              <div className="w-14 h-14 rounded-xl bg-[#E8603C] flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}